<template>
  <div>
    <b-modal
      v-model="showModal"
      v-if="isLoading"
      size="lg"
      title="Relatório Pedido"
      hide-footer
    >
      <div class="text-center p-2">
        <b-spinner variant="primary"></b-spinner>
        <p class="mt-2">Gerando PDF...</p>
      </div>
    </b-modal>
    <b-modal
      v-else
      id="modal_pdf_pedido"
      title="Relatório Pedido"
      ref="modal-pdf"
      size="lg"
      centered
      ok-title="Download"
      cancel-title="Cancelar"
      cancel-variant="outline-secondary"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <div class="flex justify-center">
        <iframe :src="pdfUrl" width="100%" height="600px"></iframe>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormSelect, BCol, BButton, BTabs, BTab, BCardText, BImg,
} from 'bootstrap-vue';
import FilesService from '@/services/Operacoes/files.service';

const filesService = new FilesService();
export default {
  components: {
    BImg, BButton, BModal, BCol, BFormSelect, BTabs, BTab, BCardText,
  },
  name: 'modal_pdf_pedido',
  data() {
    return {
      pdfUrl: '',
      isLoading: false,
      showModal: false,
    };
  },
  methods: {
    async showModalPdf(data) {
      this.isLoading = true;
      this.showModal = true;

      try {
        await filesService.indexFiles(data.pedidoId);
        this.pdfUrl = this.$store.state.filesStore.generatedLabelUrl;
      } catch (error) {
        console.error('Erro ao carregar PDF:', error);
      } finally {
        this.isLoading = false;
      }

      this.$nextTick(() => {
        this.$bvModal.show('modal_pdf_pedido');
      });
    },
    async resetModal() {
      console.log('resete-modal');
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      this.$nextTick(() => {
        this.$refs['modal-pdf'].toggle('#toggle-btn');
      });
      // Criar um link temporário para o download
      const link = document.createElement('a');
      link.href = this.pdfUrl;
      link.download = 'pedido.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>
